import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export interface ManualOrderState {
  error: {
    error: Error;
    message: string;
  };
  isLoading: boolean;
  objectId: string;
}

export const manualOrderInitialState: ManualOrderState = {
  error: {
    error: {
      message: '',
      name: '',
    },
    message: '',
  },
  isLoading: false,
  objectId: '',
};

const manualOrderReducer = (
  state: ManualOrderState = manualOrderInitialState,
  action: ActionTypes,
): ManualOrderState => {
  switch (action.type) {
    case ActionKeys.MANUALORDER_SAVE_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case ActionKeys.MANUALORDER_SAVE_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        objectId: action.payload.objectId,
      };
    case ActionKeys.MANUALORDER_SAVE_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case ActionKeys.MANUALORDER_CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        error: manualOrderInitialState.error,
      };
    case ActionKeys.MANUALORDER_RESET:
      return manualOrderInitialState;
    default:
      return state;
  }
};

export default manualOrderReducer;
